import { useEffect, useState } from "react";
import api from "../api/client";
import { Status } from "../components/Ui";

/**
 * The queue that exists because SmileOne has no status endpoint.
 *
 * A timed-out createorder may or may not have delivered. A human checks the SmileOne
 * dashboard, then marks it delivered or refunds it. Nothing here is automatic —
 * refunding an order that actually delivered costs you twice.
 */
export default function ReviewQueue() {
  const [orders, setOrders] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/admin/orders/review").then((r) => setOrders(r.data.orders)).catch(() => {});
  useEffect(() => { load(); }, []);

  async function act(orderId, action) {
    setBusy(orderId);
    try {
      await api.post(`/admin/orders/${orderId}/${action}`);
      await load();
    } catch (e) {
      alert(e.message);
    } finally {
      setBusy(null);
    }
  }

  return (
    <div>
      <h1 style={{ marginBottom: 8 }}>Needs review</h1>
      <p className="muted small" style={{ marginTop: 0, marginBottom: 24 }}>
        Check the provider dashboard before you act.
      </p>

      {orders.length === 0 && <p className="card center muted" style={{ padding: 48 }}>Nothing to review.</p>}

      {orders.map((o) => (
        <div key={o.orderId} className="card" style={{ padding: 16, marginBottom: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 16, marginBottom: 12 }}>
            <div className="grow">
              <div style={{ fontWeight: 800 }}>{o.p_info} — {o.amount}</div>
              <div className="muted small">
                #{o.orderId} · {o.customer_email} · ID {o.userId}{o.zoneId ? ` (${o.zoneId})` : ""} · ₹{o.price}
              </div>
            </div>
            <Status value={o.status} />
          </div>

          <ol style={{ background: "var(--ink-900)", borderRadius: 10, padding: 12, margin: "0 0 16px", listStyle: "none" }}>
            {(o.fulfillment || []).map((leg, i) => (
              <li key={i} style={{ display: "flex", justifyContent: "space-between", gap: 16, fontSize: 12, padding: "2px 0" }}>
                <span className="muted">Leg {i + 1} · {leg.provider}{leg.region ? ` ${leg.region}` : ""} · product {leg.productId}</span>
                <span className="mono">
                  {leg.status}
                  {leg.providerOrderId ? ` · ${leg.providerOrderId}` : ""}
                  {leg.error ? <span style={{ color: "var(--bad)" }}> · {leg.error}</span> : null}
                </span>
              </li>
            ))}
          </ol>

          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn ghost" disabled={busy === o.orderId} onClick={() => act(o.orderId, "deliver")}>
              Mark delivered
            </button>
            <button className="btn danger" disabled={busy === o.orderId}
              onClick={() => window.confirm(`Refund ₹${o.price} to ${o.customer_email}?`) && act(o.orderId, "refund")}>
              Refund ₹{o.price}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
